import axios, { CancelTokenSource } from "axios";

class RequestCanceler {
  private cancelSource: CancelTokenSource = axios.CancelToken.source();

  cancel = () => {
    this.cancelSource.cancel();
    this.cancelSource = axios.CancelToken.source();
  };

  token = () => this.cancelSource.token;
}

const requestCanceler = new RequestCanceler();

export default requestCanceler;
